module.exports = __webpack_public_path__ + "static/img/h3-4.dcfe20b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h3-4.png
// module id = 6zB9
// module chunks = 1